import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    showOverviewDetialsPopup: false, 
    dashboardOrdersSummary: {},
    overviewOrders: [],
    lastRequest: {
        pageNb: 1,
        dateFrom: "",
        dateTo: "",
        status: "",
        orderID: 0,
        type: "All",
        clientFullName: ""
    },
    driverLocation: {},
    error: null
};


const OverviewSlice = createSlice({
    name: "overview",
    initialState,
    reducers: {
        setShowOverviewDetialsPopup: (state, action) => {
            state.showOverviewDetialsPopup = action.payload;
        },
        setDashboardOrdersSummary: (state, action) => {
            state.dashboardOrdersSummary = action.payload;
        },
        setOverviewOrders: (state, action) => {
            state.overviewOrders = action.payload;
        },
        setDriverLocation: (state, action) => {
            const { lat, lng } = action.payload;
            if (!isNaN(lat) && !isNaN(lng)) {
                state.driverLocation = { lat, lng };
            } else {
                console.error("Invalid lat/lng received for driver location");
                state.driverLocation = {}; 
            }
        },
        setLastRequest: (state, action) => {
            state.lastRequest = action.payload;
        }
    },
});

export const { setShowOverviewDetialsPopup, setDashboardOrdersSummary, setOverviewOrders, setLastRequest, setDriverLocation } = OverviewSlice.actions;

export default OverviewSlice.reducer;
